<template>
  <div>
    <ion-item class="menu-category" lines="full">
      <span slot="start">
        <ion-button
          color="light"
          :disabled="upDisabled"
          @click="moveCategoryUp()"
        >
          ▲
        </ion-button>
        <ion-button
          color="light"
          :disabled="downDisabled"
          @click="moveCategoryDown"
        >
          ▼
        </ion-button>
      </span>
      <ion-label v-if="!editing" class="ion-text-wrap">{{
        category.name
      }}</ion-label>
      <ion-input
        v-else
        :value="category.name"
        @input="category.name = $event.target.value.trim()"
        ref="input"
        :required="true"
        maxlength="255"
      ></ion-input>
      <span slot="end" v-if="editing">
        <ion-button v-if="editing" @click="save()">Save</ion-button>
        <ion-button color="danger" fill="outline" @click="cancel()">
          Cancel
        </ion-button>
      </span>
      <span slot="end" v-else>
        <ion-button @click="edit()">Edit</ion-button>
        <ion-button @click="deleteConfirm()" color="danger" fill="outline">
          Delete
        </ion-button>
      </span>
    </ion-item>
    <ion-reorder-group
      class="ion-padding-start"
      disabled="false"
      @ionItemReorder="handleItemReorder($event)"
    >
      <menu-item
        v-for="(item, index) in category.items"
        :key="`item-${item.id}`"
        :value="category.items[index]"
        @save="
          category.items[index] = $event;
          save();
        "
        @delete="deleteMenuItem(item.id)"
      ></menu-item>
      <menu-item
        v-if="addingItem"
        :new-item="true"
        @save="addNewItem"
        @delete="addingItem = false"
      ></menu-item>
    </ion-reorder-group>
    <ion-list>
      <ion-item lines="none" v-if="!addingItem">
        <ion-button @click="addingItem = true" color="light">
          Add Item
        </ion-button>
      </ion-item>
    </ion-list>
  </div>
</template>

<script>
/**
 * This component was done when the time frame was very limited.
 *
 * Todo:
 * - better data validation
 */
const { v4: uuidv4 } = require("uuid");
import errorAlert from "@/ErrorAlert";
import MenuItem from "@/components/Web/MenuItem";

export default {
  components: {
    "menu-item": MenuItem
  },

  props: {
    value: {
      type: Object,
      default: function() {
        return {
          name: "",
          items: []
        };
      }
    },
    newCategory: {
      type: Boolean,
      default: false
    },
    upDisabled: {
      type: Boolean,
      default: false
    },
    downDisabled: {
      type: Boolean,
      default: false
    }
  },

  data: function() {
    return {
      editing: false,
      category: { ...this.value },
      addingItem: false
    };
  },

  mounted() {
    if (this.newCategory) {
      this.edit();
    }
  },

  methods: {
    // ideally you'd want to disable drag and drop - but when you do, all of the inputs shift, which is not good UX
    // also the ionic reset functionality just doesn't seem to work, so... cool.
    handleItemReorder(event) {
      if (this.addingItem) {
        event.detail.complete(false);
        return errorAlert("Can not reorder items while editing one.");
      }
      event.detail.complete(this.category.items);
      this.save();
    },

    focus() {
      // for some reason, next tick doesn't find this right.
      setTimeout(() => {
        this.$refs.input.setFocus();
      }, 300);
    },

    edit() {
      this.editing = true;
      this.focus();
    },

    save() {
      // very basic - and should be replaced
      if (!this.category.name) {
        return errorAlert("The category name is required.", this.focus);
      }

      this.editing = false;
      this.$emit("save", this.category);
    },

    cancel() {
      if (this.newCategory) {
        this.deleteSelf();
      } else {
        this.editing = false;
        this.category = { ...this.value };
      }
    },

    deleteConfirm() {
      return this.$ionic.alertController
        .create({
          header: "Delete Menu Category",
          subHeader: this.category,
          message:
            "Please confirm that you'd like to delete this category and <strong>all of its items</strong>.  <strong class='text-color ion-color-danger'>This can not be undone!</strong>",
          buttons: [
            {
              text: "Cancel",
              role: "cancel",
              cssClass: "cancel-button"
            },
            {
              text: "Okay",
              cssClass: "okay-button",
              handler: () => {
                this.deleteSelf();
              }
            }
          ]
        })
        .then(a => a.present());
    },

    deleteSelf() {
      this.$emit("delete");
    },

    addNewItem(item) {
      const uuid = uuidv4();

      if (!this.category.items) {
        this.category.items = [];
      }

      this.category.items.push({
        id: uuid,
        ...item
      });
      this.addingItem = false;
      this.save();
    },

    deleteMenuItem(id) {
      this.category.items.splice(
        this.category.items.findIndex(i => i.id == id),
        1
      );
      this.save();
    },

    moveCategoryUp() {
      this.$emit("up");
    },

    moveCategoryDown() {
      this.$emit("down");
    }
  }
};
</script>
